import { Routes } from '@angular/router';

import { roleGuard } from '../../core/guards/role.guard';
import { RoleCode } from '../../shared/models/user/user.enums';

export const usersRoutes: Routes = [
	{
		path: 'users',
		canMatch: [roleGuard],
		data: { allowedRoles: [RoleCode.ADMIN, RoleCode.SUPER_ADMIN] },
		children: [
			{
				path: '',
				loadComponent: () => import('./pages/users-list-page/users-list-page.component').then(c => c.UsersListPageComponent)
			}
		]
	}
];
